import { TimezoneType } from '@wix/bookings-uou-types';
export const DEFAULT_TIMEZONE = 'America/New_York';
export var BusinessPropertyName;
(function (BusinessPropertyName) {
    BusinessPropertyName["DEFAULT_TIMEZONE_PROPERTY_NAME"] = "defaultTimezone";
    BusinessPropertyName["CLIENT_CAN_CHANGE_TIMEZONE"] = "clientCanChangeTimezone";
    BusinessPropertyName["CANCELLATION_POLICY"] = "cancellationPolicy";
    BusinessPropertyName["IS_CART_ENABLED"] = "isCartEnabled";
    BusinessPropertyName["IS_MULTI_SERVICE_APPOINTMENTS_ENABLED"] = "isMultiServicesAppointmentsEnable";
})(BusinessPropertyName || (BusinessPropertyName = {}));
export function mapResponseToBusinessInfo(businessResponse) {
    const businessInfo = businessResponse.info;
    const businessProperties = businessResponse.businessProperties;
    if (businessInfo && businessProperties) {
        const defaultTimezoneType = getDefaultTimezoneType(businessProperties);
        const clientCanChangeTimezone = getClientCanChangeTimezoneIndication(businessProperties);
        const cancellationPolicy = getCancellationPolicy(businessProperties);
        const isCartEnabled = getIsCartEnabled(businessProperties);
        const isMultiServicesAppointmentsEnable = getIsMultiServicesAppointmentsEnable(businessProperties);
        const dateRegionalSettingsLocale = formatDateRegionalSettingsLocale(businessInfo.language, businessInfo.countryCode) || 'en-US';
        return {
            name: businessInfo.name,
            language: businessInfo.language,
            currency: businessInfo.currency,
            regionalSettingsLocale: businessInfo.locale,
            dateRegionalSettingsLocale,
            timeZone: businessInfo.timeZone || DEFAULT_TIMEZONE,
            timezoneProperties: {
                clientCanChooseTimezone: clientCanChangeTimezone === 'true',
                defaultTimezone: defaultTimezoneType,
            },
            countryCode: businessInfo.countryCode,
            cancellationPolicy,
            isCartEnabled,
            isMultiServicesAppointmentsEnable,
        };
    }
    return null;
}
function formatDateRegionalSettingsLocale(language, countryCode) {
    const locale = language?.split('-')[0];
    return `${locale}${countryCode ? `-${countryCode}` : ``}`;
}
export function getDefaultTimezoneType(businessProperties) {
    return (getPropertyValue(businessProperties?.customProperties, BusinessPropertyName.DEFAULT_TIMEZONE_PROPERTY_NAME) || TimezoneType.BUSINESS);
}
export function getClientCanChangeTimezoneIndication(businessProperties) {
    return (getPropertyValue(businessProperties?.customProperties, BusinessPropertyName.CLIENT_CAN_CHANGE_TIMEZONE) || 'true');
}
export function getCancellationPolicy(businessProperties) {
    return getPropertyValue(businessProperties?.customProperties, BusinessPropertyName.CANCELLATION_POLICY);
}
export function getIsCartEnabled(businessProperties) {
    const propertyValue = getPropertyValue(businessProperties?.customProperties, BusinessPropertyName.IS_CART_ENABLED);
    return propertyValue === 'true';
}
export function getIsMultiServicesAppointmentsEnable(businessProperties) {
    const propertyValue = getPropertyValue(businessProperties?.customProperties, BusinessPropertyName.IS_MULTI_SERVICE_APPOINTMENTS_ENABLED);
    return propertyValue === 'true';
}
export function getPropertyValue(properties, propertyName) {
    const property = properties?.find((businessProperty) => businessProperty.propertyName === propertyName);
    return property?.value;
}
//# sourceMappingURL=business-info.mapper.js.map